import React, { useEffect, useState } from "react";
import { useFetch } from "../../hooks/useFetch";
import { listaParticipantesExcluidos } from "../../utils/Datos";
import { PlaceholderTabla } from "../Otros/Placeholder";

export const ParticipantesExcluidos = ({
  idProcess,
  setParticipanteExcluido,
  recargar,
}) => {
  const [participantesExcluidos, setParticipantesExcluidos] = useState(null);
  const [cargandoDatos, setCargandoDatos] = useState(false);

  useEffect(() => {
    if (cargandoDatos === false) {
      setCargandoDatos(true);
      listaParticipantesExcluidos(idProcess).then((datos) => {
        setCargandoDatos(false);
        setParticipantesExcluidos(datos);
      });
    }
  }, [idProcess, recargar]);

  const handleClick = (participante) => {
    setParticipanteExcluido(participante);
  };

  return (
    <>
      {cargandoDatos ? (
        <PlaceholderTabla></PlaceholderTabla>
      ) : (
        <>
          <div className="table-responsive">
            <table className="table table-rounded table-striped border gy-7 gs-7">
              <thead>
                <tr className="fw-bold fs-6 text-gray-800 border-bottom border-gray-200">
                  <th>Nombre</th>
                  <th>Rut</th>
                  <th>Dirección</th>
                  <th>Mótivo</th>
                  <th>Acciones</th>
                </tr>
              </thead>
              <tbody>
                {participantesExcluidos == null ||
                participantesExcluidos.length <= 0 ? (
                  <tr>
                    <td colSpan={5}>No hay participantes excluídos</td>
                  </tr>
                ) : (
                  participantesExcluidos.map((participante) => {
                    return (
                      <tr key={participante.id_participant}>
                        <td>{participante.officerName}</td>
                        <td>{participante.officerRut}</td>
                        <td>{participante.nameUmunicipal}</td>
                        <td>{participante.commentExclusion}</td>
                        <td>
                          <a
                            href=""
                            data-bs-toggle="modal"
                            data-bs-target="#m-eliminar-excluido"
                            onClick={() => handleClick(participante)}
                          >
                            <i
                              title={`Excluir funcionario`}
                              className="fas fa-trash text-danger"
                            ></i>
                          </a>
                        </td>
                      </tr>
                    );
                  })
                )}
              </tbody>
            </table>
          </div>
        </>
      )}
    </>
  );
};
